import { Alert, Button, Stack } from '@mui/material'
import { useState } from 'preact/hooks'
import { api } from '../api/client'
import type { Position } from '../api/generated/Position'
import type { Preferences } from '../api/generated/Preferences'
import { useAction } from '../api/useAction'
import { useApi } from '../api/useApi'
import {
  PreferencesFields,
  type PreferencesForm,
  preferencesForm,
  preferencesOf,
} from './PreferencesFields'

/** A volunteer's availability and positions of interest, to give or change at any time. */
export function MyPreferences({
  slug,
  days,
  positions,
}: {
  slug: string
  days: string[]
  positions: Position[]
}) {
  const path = `/events/${slug}/preferences`
  const preferences = useApi<Preferences>(path)
  const [edited, setEdited] = useState<PreferencesForm>()
  const [saved, setSaved] = useState(false)
  const { error, pending, run } = useAction()
  if (preferences.error) return <Alert severity="error">{preferences.error}</Alert>
  if (!preferences.data) return null

  const form = edited ?? preferencesForm(preferences.data, days)
  const submit = (e: Event) => {
    e.preventDefault()
    run(async () => {
      preferences.setData(await api.post<Preferences>(path, preferencesOf(form)))
      setEdited(undefined)
      setSaved(true)
    })
  }
  return (
    <Stack component="form" spacing={2} onSubmit={submit}>
      {preferences.data.availability.length === 0 && (
        <Alert severity="info">
          Indiquez quand vous êtes disponible et les postes qui vous intéressent : les organisateurs
          vous affecteront ensuite à des créneaux.
        </Alert>
      )}
      <PreferencesFields
        slug={slug}
        days={days}
        positions={positions}
        value={form}
        onChange={(next) => {
          setEdited(next)
          setSaved(false)
        }}
      />
      {error && <Alert severity="error">{error}</Alert>}
      {saved && <Alert severity="success">Disponibilités enregistrées.</Alert>}
      <Button
        type="submit"
        variant="outlined"
        disabled={!edited}
        loading={pending}
        sx={{ alignSelf: 'flex-start' }}
      >
        Enregistrer
      </Button>
    </Stack>
  )
}
